import React, {FC} from "react";
import cls from "../../shop.module.scss";
import Currency from "../../../shared/Currency";
import RemoveButton from "../RemoveButton";

interface IFooter {
    itemId: number;
    TotalIntl: string;
    formattedBaseTotal: string;
    DeleteIntl: string
}

const Footer:FC<IFooter> = ({ itemId, TotalIntl, formattedBaseTotal, DeleteIntl }) => {
    return (
        <div className={cls.mobile_cart_footer}>
            <div className={`
                ${cls["cart-table__column"]}
                ${cls["cart-table__column--remove"]}
            `}>
                <RemoveButton isAlternative={false} cartItemId={itemId} DeleteIntl={DeleteIntl} />
            </div>
            <div className={`
                ${cls["cart-table__column"]}
                ${cls["cart-table__column--total"]}
                ${cls["column--total-fms"]}
            `}>
                <span className={`${cls["d-none"]} ${cls["data-title-mob"]}`}>
                    {TotalIntl}
                </span>
                <span className={cls["cart-table__column-fm"]}>
                    <Currency value={formattedBaseTotal}/>
                </span>
            </div>
        </div>
    )
}

export default Footer;
